const vzMainNav = document.getElementById('menu-hauptnavigation');
const vzCatBooks = document.body.classList.contains('category-238');
const vzCatAuthor = document.body.classList.contains('author');
const vzCatArchives = document.body.classList.contains('archive') ||
    document.body.classList.contains('category');
const vzCatParent = vzMainNav ?
    (vzMainNav.querySelector('.current-category-parent') ||
    vzMainNav.querySelector('.current-menu-item')) : null;

if (vzCatParent && !vzCatBooks && !vzCatAuthor) {
  vzCatParent.classList.add('wav-active');
}

/**
 * returns category slug from a string containing classes
 * @param {string} classes
 * @return {string}
 */
function vzMenuCat( classes ) {
  const regex = /vz-cat-([a-z-]+)/i;

  const categoryMatches = classes.match(regex);
  if (categoryMatches === null) return '';
  const selectedTaxonomy = categoryMatches[1];

  return selectedTaxonomy;
}

/**
 * Menu behavior for archive pages
 * Native JS only - no jQuery
 */
function vzMenuArchives() {
  const menuContainer = document.getElementById('top-bar-menu');
  const mainNav = document.getElementById('menu-hauptnavigation');

  if (!mainNav || !menuContainer) return;

  // Event delegation: single click handler on parent instead of N handlers
  menuContainer.addEventListener('click', function(e) {
    const link = e.target.closest('#menu-hauptnavigation > li > a');
    if (!link) return;

    e.preventDefault();

    const currentMenuCat = link.parentElement;
    const parentClasses = currentMenuCat.getAttribute('class');
    const selectedTaxonomy = vzMenuCat(parentClasses);

    if (!selectedTaxonomy) return;

    // Remove wav-active from siblings
    const siblings = currentMenuCat.parentElement.children;
    for (let i = 0; i < siblings.length; i++) {
      if (siblings[i] !== currentMenuCat) {
        siblings[i].classList.remove('wav-active');
      }
    }
    currentMenuCat.classList.add('wav-active');

    // Show/hide tag menus
    const tagMenuLists = menuContainer.querySelectorAll('.menu-tag-list ul');
    tagMenuLists.forEach(list => {
      list.classList.add('hide');
      if (list.getAttribute('data-cat-slug') === selectedTaxonomy) {
        list.classList.remove('hide');
      }
    });
  });

  // Foundation.js dropdown menu event (if Foundation is loaded)
  menuContainer.addEventListener('hide.zf.dropdownMenu', function() {
    const links = mainNav.querySelectorAll('li > a');
    links.forEach(link => link.classList.remove('wav-active'));
  });
}

/**
 * Menu navigation controls
 * Native JS only - no jQuery
 */
function vzMenuNav() {
  if (!vzMainNav) return;

  // The mega nav this function used to fill by AJAX lost its markup
  // (.latest-posts / .top-bar-posts) in 3278b41, so the request never went out
  // and only the archive menu is left here.
  if (vzCatArchives && !vzCatBooks) {
    vzMenuArchives();
  }
}
